import {Component, computed, input} from '@angular/core';
import {ActivityIcon, LucideAngularModule, TicketIcon} from 'lucide-angular';
import {ActivityType} from '@domain/activity/activity.dto';

@Component({
  selector: 'app-activity-type-icon',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './activity-type-icon.component.html'
})
export class ActivityTypeIconComponent {

  public readonly type = input.required<ActivityType | null | undefined>();
  public readonly icon = computed(() => {
    const type = this.type();
    return type ? this.icons?.[type] : null;
  });

  private readonly icons = {
    [ActivityType.Activity]: ActivityIcon,
    [ActivityType.Event]: TicketIcon
  };
}
